import PricePackage from './PricePackage'

export * from './PricePackage'

export default PricePackage
